import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerUrlService } from 'src/app/services/server-url.service'; 

@Injectable({
  providedIn: 'root'
})
export class AgendasService {

  constructor(
    private http: HttpClient,
    private serverUrlService: ServerUrlService
  ) { }

  consultaAgendas() {
    return this.http.get(`${this.serverUrlService.getUrl()}/agendas`);
  }

  consultaAgendasEspecialidades() {
    return this.http.get(`${this.serverUrlService.getUrl()}/especialidadesagenda`);
  }

  consultaAgendasConvenios(myAgendas: any, myExames: any) {
    const myBody = {
      agendas : myAgendas,
      exames : myExames
    };
    return this.http.post(`${this.serverUrlService.getUrl()}/agendas/convenios`, myBody);
  }

  consultaAgendaProcedimentos() {
    return this.http.get(`${this.serverUrlService.getUrl()}/agendas/procedimentos`);
  }
}
